import { Stack, Flex, useToast } from "@chakra-ui/react";
import { Display03, Paragraph02 } from "~/components/Texts";
import Spinner from "~/components/animations/Spinner";
import { useEffect } from "react";
import { useRouter } from "next/router";
import { createShop, setShopLogo } from "~/actions/ShopActions";
import * as Sentry from "@sentry/nextjs";

export default function OnboardingShopCreation({ onboardingData, onBack }) {
  const router = useRouter();
  const toast = useToast();

  useEffect(() => {
    var shopId;

    createShop(onboardingData)
      .then((result) => {
        shopId = result.data.shopId;
        if (onboardingData.localLogoFile) {
          return setShopLogo(shopId, onboardingData.localLogoFile);
        }
      })
      .then(() => {
        router.replace(
          {
            pathname: "/[shopDomain]/control",
            query: { onboarding: true },
          },
          "/" + onboardingData.domain + "/control?onboarding=true"
        );
      })
      .catch((error) => {
        Sentry.captureException(error);
        showErrorToast();
        onBack();
      });
  }, []);

  const showErrorToast = () => {
    toast({
      title: "Upss",
      description:
        "No pudimos crear tu tienda en este momento. Intentalo otra vez en unos minutos.",
      status: "error",
      duration: 3000,
      isClosable: true,
      position: "top",
    });
  };

  return (
    <Flex flex="1" direction="column">
      <Stack height="100%" width="100%" spacing="8">
        <Flex
          flex="1"
          width="100%"
          direction="column"
          justify="center"
          align="center"
        >
          <Display03 textAlign="center">
            ¡Estamos abriendo tu tienda al mundo!
          </Display03>
          <Spinner height={300} width={300} />
          <Paragraph02 textAlign="center">
            La historia de tu negocio comienza ahora.
          </Paragraph02>
          <Paragraph02 textAlign="center">¿Estás preparado?</Paragraph02>
        </Flex>
      </Stack>
    </Flex>
  );
}
